/**
 *
 * Campaigns/Form/OptIn
 *
 */

import React, { memo, useEffect } from 'react'

// Graphql
import useQuery from 'components/UseQuery'
import { gql } from '@apollo/client'

// Components
import DropDownMenu from 'components/DropDownMenu'
import OptInRequired from 'components/Preferences/OptIns/Required'
import { BlockedMessage } from 'components/Organizations/Index'

const GET_OPT_INS = gql`
	query user($user_id: ID!) {
		user(id: $user_id) {
			id
			opt_ins {
				id
				name
				text
				global_default
			}
			opt_in_id
			handle_opt_in
		}
	}
`

function OptIn({ user_id, campaign_state, mergeState, disabled, organization, current_user_is_god }) {
	const {
		data: { user },
		loading,
	} = useQuery(GET_OPT_INS, {
		variables: { user_id },
		channels: [user_id],
	})

	useEffect(() => {
		if (campaign_state?.id.length) return
		if (campaign_state?.opt_in_id?.length) return

		if (!(organization || user)?.opt_ins?.some((opt_in) => opt_in.id === campaign_state.opt_in_id)) {
			let new_state = {}

			if (organization) {
				new_state = {
					opt_in_id: organization.opt_in_id,
					handle_opt_in: organization.opt_in_default_behaviors[organization.opt_in_id],
				}
			} else if (user) {
				new_state = {
					opt_in_id: user.opt_in_id,
					handle_opt_in: user.handle_opt_in,
				}
			}

			mergeState(new_state)
		}
	}, [JSON.stringify(user)])

	const opt_ins = (organization || user)?.opt_ins || []

	const selected_opt_in = opt_ins.find((opt_in) => opt_in.id === campaign_state.opt_in_id)

	const disabled_by_organization = !!organization && !current_user_is_god

	return (
		<div>
			<div className="d-flex flex-wrap">
				{disabled_by_organization && <BlockedMessage category="Contact Opt-Ins" />}
				<span className="text-muted mr-3">Contact Opt-In:</span>

				{disabled_by_organization ? (
					<span>
						<b>{selected_opt_in?.name}</b>
					</span>
				) : (
					<DropDownMenu
						Button={selected_opt_in?.name || (loading ? '' : 'None')}
						className="mr-4"
						position="right"
						disabled={disabled || disabled_by_organization}
						menu_style={{ width: '500px' }}
					>
						<ul className="list-unstyled" style={{ maxWidth: '' }}>
							<li
								onClick={() => mergeState({ opt_in_id: null, handle_opt_in: null })}
								role="presentation"
							>
								None
							</li>

							{opt_ins.map((opt_in) => (
								<li
									key={opt_in.id}
									onClick={() =>
										mergeState({
											opt_in_id: opt_in.id,
											handle_opt_in: 1,
										})
									}
									role="presentation"
									className="d-flex"
								>
									<div className="mr-3 font-weight-bold">{opt_in.name}</div>
									<div className="overflow-hidden text-muted">{opt_in.text}</div>
								</li>
							))}
						</ul>
					</DropDownMenu>
				)}
			</div>

			{selected_opt_in && (
				<OptInRequired
					handle_opt_in={campaign_state.handle_opt_in}
					onChange={(value) => mergeState({ handle_opt_in: value })}
					opt_in={selected_opt_in}
					disabled={disabled || disabled_by_organization}
				/>
			)}
		</div>
	)
}

export default memo(OptIn)
